import {useModal} from '@ui/Modal';
import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {useAuthAxios} from '@hooks/useAuthAxios';
import {ButtonPrimary} from '@ui/Button';
import {Navigate, Outlet, useNavigate} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from '@hooks/app';
import {useExpiresToken} from '@hooks/useExpiresToken';
import {setToken} from '@store/app.slice';
import {useEventListener} from 'usehooks-ts';
import {useGetUserProfileQuery} from '../../pages/Profile/Profile.api';

class AuthChecker {
    #states: boolean[] = [];
    get shouldWarn() {
        const [initial, last] = this.#states;

        return initial && last === false;
    }

    push(isAuth: boolean) {
        const [last] = [...this.#states].reverse();
        if (last !== isAuth) {
            this.#states.push(isAuth);
            this.#states.splice(0, this.#states.length - 2);
        }
    }
}

export const LogoutNotificationDialog = (data: any) => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/login');
    }, []);

    return <>
        <p className='text-h2'>
            Вы вошли с другого устройства.
            <br/>
            Если это не вы, <a href='/recovery-password'>сбросьте пароль</a>
        </p>
        <br/>
        {/* @ts-ignore*/}
        <ButtonPrimary onClick={() => window.location = '/login'}>
            Войти
        </ButtonPrimary>
    </>;
};

export const SessionExpiredDialog = (_data: any) => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/login');
    }, []);

    return <>
        <p className='text-h2'>
            Сессия истекла. Пожалуйста, войдите снова.
        </p>
        <br/>
        {/* @ts-ignore*/}
        <ButtonPrimary onClick={() => window.location = '/login'}>
            Войти
        </ButtonPrimary>
    </>;
};

export const CheckAuthDialog = () => {

    const {not_expires} = useExpiresToken();
    const {token} = useAppSelector(state => state.app);
    const {data: user, refetch: getUserProfile, isError} = useGetUserProfileQuery({token: token});
    const dialogRef = useModal(() => <LogoutNotificationDialog/>);
    const sessionExpiredDialogRef = useModal(() => <SessionExpiredDialog/>);
    const dispatch = useAppDispatch();
    const blurTmr = useRef<number>();
    const [suspended, setSuspended] = useState(false);

    const makeLogout = useCallback(() => {
        dispatch(setToken({token: null, expires_at: null}));
        dialogRef.open({});
    }, []);

    const makeSessionExpiredLogout = useCallback(() => {
        dispatch(setToken({token: null, expires_at: null}));
        sessionExpiredDialogRef.open({});
    }, []);
    const handleWindowFocus = useCallback(async () => {
        if (blurTmr.current) {
            clearInterval(blurTmr.current);
        }

        if (suspended) {
            setSuspended(false);
            getUserProfile();
        }

    }, [suspended]);
    const handleWindowBlur = useCallback(() => {
        let lastTs = Date.now();
        // таймер выполняется на каждом фрейме
        // рано или поздно вкладка уйдёт в сон
        // в таком режиме таймер сначала будет выполняться просто медленно
        // а потом остановится
        // в такой момент разница newTs и lastTs будет большой
        // это будет означать что мы выгрузились из сна и нужно снова проверить статус авторизации
        blurTmr.current = setInterval(() => {
            const newTs = Date.now();

            if (newTs - lastTs > 1000) {
                setSuspended(true);
            }

            lastTs = newTs;
        }, 1) as any;
    }, []);

    useEventListener('focus', handleWindowFocus, window as any);
    useEventListener('blur', handleWindowBlur, window as any);

    useEffect(() => {
        setTimeout(() => {
            if (token?.token && isError) {
                makeSessionExpiredLogout();
            }
        }, 1000);
    }, [isError, token?.token]);

    useEffect(() => {
        if (!token || !not_expires || !user?.id || !window['makeEcho']) return;

        const Echo = makeEcho(token.token);

        const ch = Echo.private(`logout.${user.id}`);

        ch.subscribed(() => console.info(`подписан на logout.${user.id}`))
            .error((err: any) => console.warn('ошибка канала', err))
            .listen('.user.logout', makeLogout);

        return () => {
            try {
                Echo.leave(`logout.${user.id}`);
                Echo.disconnect();
            } catch {}
        };
    }, [token?.token, not_expires, user?.id]);

    /*const dialogRef = useModal(() => <LogoutNotificationDialog/>);
    const [isFetched, setIsFetched] = useState(0);
    const checker = useMemo(() => new AuthChecker(), []);
    const axios = useAuthAxios();
    const [isShown, setIsShown] = useState(false);

    useEffect(() => {
        const tmr = setInterval(() => axios
            .get('user')
            .then(() => checker.push(true))
            .catch(() => checker.push(false))
            .finally(() => setIsFetched(Math.random()))
            , 1000 * 60
        );
        return () => clearInterval(tmr);
    }, []);

    useEffect(() => {
        if (!isFetched) {
            return;
        }

        if (checker.shouldWarn && !isShown) {
            dialogRef.open({});
            setIsShown(true);
        }
    }, [isFetched, checker.shouldWarn, isShown]);*/

    return <></>;
};
